import Component from '../../../components/Component';

import keys from './keys';
import query from './query';
import ListData from '../../../components/ListData';
import { withTranslation } from 'react-i18next';

class Summary extends Component {
    constructor() {
        super();
        this.query = query;
    }
    render() {
        const { t } = this.props;

        return (
            <ListData
                loading={this.state.loading}
                header={
                    this.props.header ?? t('search.overview.topKeywords.summaryList.topKeywords')
                }
                subheader={
                    this.props.subheader ?? t('search.overview.topKeywords.summaryList.byClicks')
                }
                forceRun={this.forceRun}
                link={`/domain/${this.props.domain_id}/gsc-reports/categories`}
                keys={keys(t)}
                uniqKey="level"
                data={this.state.data}
                cardClassName={'list-data-full'}
            />
        );
    }
}

export default withTranslation()(Summary);
